export default __webpack_public_path__ + "static/media/0b8c54d3-a43f-47e0-889c-c8ed6076fa9e.cb19825b.JPG";